import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DynamicComponent from './DynamicComponent';
import { setModalProps } from '@wsc/redux_stores/modalsReducer';
import useLocalize from '../../hooks/useLocalize';
import { getFilename } from '@wsc/utils/fileUtils';
import { useAnalytics, useLocalizedNavigation } from '@wsc/hooks';

const DynamicActionComponent = ({ remoteConfig, properties }) => {
	const {
		actionType,
		actionProps,
		localizedActionProps,
		imageUrl,
		ga4Tags = {},
	} = properties;
	const { enabled: isLocaleEnabled, activeLocale } = useLocalize();
	const { collect } = useAnalytics();
	const dispatch = useDispatch();
	const { navigate } = useLocalizedNavigation();

	const actions = {
		redirectUrl: ({ link }) => window.open(link, '_blank'),
		navigate: ({ sceneName }) => navigate(sceneName),
		triggerModal: ({ selector, modalProps }) =>
			dispatch(
				setModalProps({
					key: selector,
					props: { visible: true, ...modalProps },
				}),
			),
		triggerKeyPress: ({ key }) => {
			window.dispatchEvent(new KeyboardEvent('keydown', { key: key }));
		},
	};

	const handleClick = () => {
		collect({
			event_name: ga4Tags?.eventName || 'click_custom',
			action: ga4Tags?.action || 'Clickable image clicked',
			content_URL: imageUrl,
			content_name: getFilename(imageUrl),
		});
		actions[actionType](
			isLocaleEnabled ? localizedActionProps[activeLocale] : actionProps,
		);
	};

	return (
		<DynamicComponent
			remoteConfig={remoteConfig}
			{...properties}
			onClick={handleClick}
		/>
	);
};

export default DynamicActionComponent;
